import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked_3",
  "use": "checked_3-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"checked_3\"><path d=\"M3.552 9.996l4.083 3.507 8.57-12.78c.473-.767 1.402-.954 2.076-.416l.113.095c.674.538.838 1.596.366 2.364L9.407 19.174c-.353.575-.703.774-1.318.82-.615.047-.987-.213-1.356-.634L1.41 12.43c-.59-.67-.59-1.76 0-2.43l.007-.004c.59-.671 1.545-.671 2.134 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol